import { Row } from '@tanstack/react-table'

import { DomainAlerts } from 'features/inventory/domain'
import { Domain } from 'features/inventory/types/domain'
import { Workspace } from 'features/workspace/types/workspace'
import WorkspaceAlerts from '../../WorkspaceAlerts'
import { WorkspaceForTable } from '../types'
import { isWorkspaceRow } from './utils'

export const AlertsCell = ({ depth, original }: Row<WorkspaceForTable>) => {
  const alerts: Domain['alerts'] | Workspace['alerts'] = original.alerts

  return isWorkspaceRow(depth) ? (
    <WorkspaceAlerts alerts={alerts} />
  ) : (
    <DomainAlerts alerts={alerts as unknown as Domain['alerts']} />
  )
}
